import Vue from 'vue';
import VueI18n from 'vue-i18n'
import enLang from './en'
import zhLang from './zh'
import esLang from './es'
import ptBRLang from './pt-BR'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import enLocale from 'element-ui/lib/locale/lang/en'
import esLocale from 'element-ui/lib/locale/lang/es'
import ptBRLocale from 'element-ui/lib/locale/lang/pt-br'
import { Storage } from '@/utils';

Vue.use(VueI18n);

let locale = Storage.get('lang');

// 若没有Storage，取浏览器默认语言，非中文环境均设为en
if (!locale) {
    let defaultLang = navigator.language;

    if (defaultLang !== 'zh-CN') {
        locale = 'en';
        Storage.set('lang', 'en');
    } else {
        locale = 'zh-CN';
        Storage.set('lang', 'zh-CN');
    }
}

export default new VueI18n({
    locale, // set locale
    messages: {      // set locale messages
        'zh-CN': Object.assign(zhLang, zhLocale),
        'en': Object.assign(enLang, enLocale),
        'es': Object.assign(esLang, esLocale),
        'pt-BR': Object.assign(ptBRLang, ptBRLocale),
    },
});
